import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@orion/environment';
import { Observable, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ConfigService } from '../configuration/config.service';
import { LOGGING_ENDPOINT_PATH } from './logging.consts';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly config = inject(ConfigService);
  private readonly http = inject(HttpClient);

  logErrorToApi(error: unknown): Observable<unknown> {
    return this.http.post<unknown>(this.endpoint(), error).pipe(
      retry(3),
      catchError((): Observable<null> => of(null)),
    );
  }

  /**
   * Where the errors go.
   * `userSettingsService` already holds that environment's API root; the
   * logger lives under it. The compiled value stays as the answer for an error
   * thrown before the configuration is loaded, and for a local build that has
   * none.
   * @returns {string} The endpoint this environment logs to.
   */
  private endpoint(): string {
    const apiRoot = this.config.getSettings('userSettingsService') as string | undefined;

    return apiRoot ? `${apiRoot}${LOGGING_ENDPOINT_PATH}` : environment.loggingEndpoint;
  }
}
